import {
  Component,
  Input,
  HostBinding,
  TemplateRef,
} from '@angular/core';

@Component({
  selector: 'suka-input-group',
  template: `
    <label *ngIf="label" class="label">
      <ng-container *ngIf="!isTemplate(label)">{{label}}</ng-container>
      <ng-template *ngIf="isTemplate(label)" [ngTemplateOutlet]="label"></ng-template>
    </label>
    <div *ngIf="helperText" class="form__helper-text">
      <ng-container *ngIf="!isTemplate(helperText)">{{helperText}}</ng-container>
      <ng-template *ngIf="isTemplate(helperText)" [ngTemplateOutlet]="helperText"></ng-template>
    </div>
    <div class="input-group-wrapper">
      <div
        class="input-group-content"
        [ngClass]="{
          'input-group-content--condensed': condensed
        }"
        [attr.data-invalid]="(invalid ? true : null)"
      >
        <ng-content></ng-content>
      </div>
      <div *ngIf="invalid" class="form-requirement">
        <ng-container *ngIf="!isTemplate(invalidText)">{{invalidText}}</ng-container>
        <ng-template *ngIf="isTemplate(invalidText)" [ngTemplateOutlet]="invalidText"></ng-template>
      </div>
    </div>
  `,
})
// tslint:disable-next-line: component-class-suffix
export class InputGroup {
  @HostBinding('class.form-item') containerClass = true;

  /**
   * Set to `true` for an invalid input group component.
   */
  @Input() invalid = false;
  /**
   * Sets the text inside the `label` tag.
   */
  @Input() label: string | TemplateRef<any>;
  /**
   * Sets the optional helper text.
   */
  @Input() helperText: string | TemplateRef<any>;
  /**
   * Sets the invalid text.
   */
  @Input() invalidText: string | TemplateRef<any>;
  /**
   * Set to `true` for a condesned input group component;
   */
  @Input() condensed = false;

  public isTemplate(value) {
    return value instanceof TemplateRef;
  }

}
